import { ShieldCheck, Lock, BadgeCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "@/data/site";
import { scrollToId } from "@/lib/lenis";

const BADGES = [
  { icon: BadgeCheck, label: "Assessoria Cadastrada & Homologada" },
  { icon: Lock, label: "Sigilo de Dados LGPD" },
  { icon: ShieldCheck, label: "Certificação SSL 256-Bit" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-gold-400/15 bg-navy-950">
    <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
      <div className="flex flex-col items-start justify-between gap-10 lg:flex-row lg:items-center">
        <button onClick={() => scrollToId("#inicio")} className="flex items-center gap-4">
          <img
            src={BRAND.logo}
            alt="Melo Vistos"
            className="h-12 w-12 rounded-md border border-gold-400/40 object-cover"
          />
          <span className="text-left">
            <span className="block font-mono-tech text-sm font-semibold tracking-[0.28em] text-slate-100">
              MELO <span className="text-gold-400">VISTOS</span>
            </span>
            <span className="mt-1 block font-serif-display text-sm italic text-slate-400">
              Sua rota segura para os principais destinos do mundo
            </span>
          </span>
        </button>

        <div className="flex flex-wrap gap-6">
          {BADGES.map((b) => (
            <span key={b.label} className="flex items-center gap-2 text-xs font-light text-slate-400">
              <b.icon className="h-4 w-4 text-gold-400" />
              {b.label}
            </span>
          ))}
        </div>
      </div>

      <div className="mt-10 flex flex-col gap-3 border-t border-gold-400/10 pt-8 font-mono-tech text-[10px] tracking-wider text-slate-500 sm:flex-row sm:items-center sm:justify-between">
        <p>
          RAZÃO SOCIAL: {BRAND.name.toUpperCase()} • CNPJ: {BRAND.cnpj}
        </p>
        <p>
          {BRAND.phone} • {BRAND.email.toUpperCase()} • SÃO PAULO - SP - BRASIL
        </p>
      </div>
      <div className="mt-4 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <p className="max-w-2xl text-[11px] font-light leading-relaxed text-slate-600">
          A Melo Vistos & Passaportes Ltda presta serviços de assessoria
          documental e preparação consular. A concessão de vistos é decisão
          exclusiva e soberana dos consulados, embaixadas e órgãos de imigração
          de cada país; nenhum resultado é garantido.
        </p>
        <Link
          data-testid="footer-privacy-link"
          to="/privacidade"
          className="w-fit shrink-0 font-mono-tech text-[10px] tracking-wider text-slate-500 underline-offset-4 transition-colors hover:text-gold-300 hover:underline"
        >
          POLÍTICA DE PRIVACIDADE
        </Link>
      </div>
    </div>
  </footer>
);
